import {Box, Flex} from '@chakra-ui/react';
import {
	DesktopSideImage,
	FullPageCentered,
	FullPageNormal,
	LanguageSelector
} from 'components';
import {MobileTop} from 'components/banner/MobileTop';
import {FullPageAll} from 'components/layout/FullPage';
import {NoSideBar} from 'components/layout/NoSideBar';
import {GeoNav} from 'components/navs/GeoNav';
import {GeoHeaderText} from 'components/text/GeoHeaderText';
import React, {PropsWithChildren} from 'react';
import {useResponsive} from 'utils/useResponsive';

interface GeoAuthLayoutProps {
	footer?: JSX.Element;
}

export const GeoAuthLayout: React.FC<PropsWithChildren<GeoAuthLayoutProps>> = ({
	footer,
	...props
}: GeoAuthLayoutProps) => {
	const {isMobile} = useResponsive();

	const banner = isMobile ? null : (
		<DesktopSideImage
			image='/images/banner.jpg'
			height='calc(100vh - 104px)'
			logo='/images/groupe165.png'
		/>
	);

	const top = isMobile ? <MobileTop /> : null;

	const footerWithLayout = (
		<Flex
			sx={{
				px: [4, 6, 12],
				mb: [6, 14, 14]
			}}
		>
			{footer}
		</Flex>
	);

	return (
		<>
			<NoSideBar
				top={top}
				banner={banner}
				footer={footerWithLayout}
				isMobile={isMobile}
				{...props}
			/>
			{isMobile ? null : (
				<Box
					h='max-content'
					w='max-content'
					position='fixed'
					top='2em'
					right='2em'
				>
					<LanguageSelector />
				</Box>
			)}
		</>
	);
};

interface GeoHomeLayoutProps {
	header?: JSX.Element;
	footer?: JSX.Element;
	title?: string;
}

export const GeoHomeLayout: React.FC<PropsWithChildren<GeoHomeLayoutProps>> = ({
	header,
	footer,
	title,
	...props
}: GeoHomeLayoutProps) => {
	const {isMobile} = useResponsive();

	const headerText = title ? <GeoHeaderText>{title}</GeoHeaderText> : null;

	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;

	return (
		<FullPageCentered
			top={top}
			header={headerText}
			footer={navMobile}
			{...props}
		/>
	);
};

export const GeoHomeMoreLayout: React.FC<
	PropsWithChildren<GeoHomeLayoutProps>
> = ({header, footer, ...props}: GeoHomeLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return <FullPageNormal top={top} footer={navMobile} {...props} />;
};

interface GeoSearchLayoutProps {
	footer?: JSX.Element;
	height?: string;
}

export const GeoSearchLayout: React.FC<
	PropsWithChildren<GeoSearchLayoutProps>
> = ({footer, ...props}: GeoSearchLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageCentered
			top={top}
			footer={navMobile}
			isMobile={isMobile}
			{...props}
		/>
	);
};

export const GeoSearchMoreLayout: React.FC<
	PropsWithChildren<GeoSearchLayoutProps>
> = ({footer, ...props}: GeoSearchLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageNormal
			top={top}
			footer={navMobile}
			isMobile={isMobile}
			{...props}
		/>
	);
};

export interface GeoTestLayoutProps {
	footer?: JSX.Element;
}

export const GeoTestLayout: React.FC<PropsWithChildren<GeoTestLayoutProps>> = ({
	footer,
	...props
}: GeoTestLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageNormal
			top={top}
			// header={headerText}
			footer={navMobile}
			isMobile={isMobile}
			{...props}
		/>
	);
};

export interface GeoProfileLayoutProps {
	footer?: JSX.Element;
}

export const GeoProfileLayout: React.FC<
	PropsWithChildren<GeoProfileLayoutProps>
> = ({footer, ...props}: GeoProfileLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageNormal
			top={top}
			footer={navMobile}
			isMobile={isMobile}
			{...props}
		/>
	);
};

export interface GeoScanLayoutProps {
	footer?: JSX.Element;
}

export const GeoScanLayout: React.FC<PropsWithChildren<GeoScanLayoutProps>> = ({
	footer,
	...props
}: GeoScanLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageNormal
			top={top}
			footer={navMobile}
			isMobile={isMobile}
			{...props}
		/>
	);
};
export const GeoScanDetailsLayout: React.FC<
	PropsWithChildren<GeoScanLayoutProps>
> = ({footer, ...props}: GeoScanLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageAll top={top} footer={navMobile} isMobile={isMobile} {...props} />
	);
};

export interface GeoCreditLayoutProps {
	footer?: JSX.Element;
}

export const GeoCreditLayout: React.FC<
	PropsWithChildren<GeoCreditLayoutProps>
> = ({footer, ...props}: GeoCreditLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageNormal
			top={top}
			footer={navMobile}
			isMobile={isMobile}
			{...props}
		/>
	);
};
export interface GeoScanFaisaLayoutProps {
	footer?: JSX.Element;
}

export const GeoScanFaisaLayout: React.FC<
	PropsWithChildren<GeoScanFaisaLayoutProps>
> = ({footer, ...props}: GeoScanFaisaLayoutProps) => {
	const {isMobile} = useResponsive();
	const top = isMobile ? <Flex></Flex> : <GeoNav isMobile={isMobile} />;
	const navMobile = isMobile ? <GeoNav isMobile={isMobile} /> : null;
	return (
		<FullPageNormal
			top={top}
			footer={navMobile}
			isMobile={isMobile}
			{...props}
		/>
	);
};
